import { render, staticRenderFns } from "./header-white.vue?vue&type=template&id=516985b2&lang=pug&"
import script from "./header-white.vue?vue&type=script&lang=js&"
export * from "./header-white.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports